import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-preinscribir',
  templateUrl: './preinscribir.component.html',
  styleUrls: ['./preinscribir.component.css']
})
export class PreinscribirComponent implements OnInit {
  tituloModal:string = "";
  mensajeModal:string = "";
  modalUtilizado:string = "";
  mantenerModal:boolean = false;
  actualizarModal:number = 0;

  seIngresoCurp:boolean = false;

  constructor( private ruta:Router ) { }

  ngOnInit(): void {
  }


  

}
